import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const putSolicitationEditThunk = createAsyncThunk(
    `SolicitationEditSlicer/putSolicitationEditThunk`,
    async (payload, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login']
        };

        const { redemptionId } = payload;

        const { data } = await conciergeApiClient.put(`/Redemption/${redemptionId}`, payload, { headers });

        return data;
    }
);

const initialState = {
    dataSolicitationEdit: null,
    loadingSolicitationEdit: false,
    errorSolicitationEdit: false,
};

const SolicitationEditSlicer = createSlice({
    name: 'SolicitationEdit',
    initialState,
    reducers: {
        resetDataSolicitationEdit: (state) => {
            state.dataSolicitationEdit = null;
            state.loadingSolicitationEdit = false;
            state.errorSolicitationEdit = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(putSolicitationEditThunk.pending, (state) => {
            state.dataSolicitationEdit = null;
            state.loadingSolicitationEdit = true;
            state.errorSolicitationEdit = false;
        });
        builder.addCase(putSolicitationEditThunk.fulfilled, (state, action) => {
            state.dataSolicitationEdit = action.payload;
            state.loadingSolicitationEdit = false;
            state.errorSolicitationEdit = false;
        });
        builder.addCase(putSolicitationEditThunk.rejected, (state) => {
            state.dataSolicitationEdit = null;
            state.loadingSolicitationEdit = false;
            state.errorSolicitationEdit = true;
        });
    },
});

export const { resetDataSolicitationEdit } = SolicitationEditSlicer.actions;
export default SolicitationEditSlicer.reducer;